import React from 'react';

const Header = () => {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="logo-section">
          <img src="/logo.png" alt="7Universe" className="logo" />
          <h1 className="app-title">7Universe</h1>
        </div>
      </div>
    </header>
  );
};

export default Header;